import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ERR_TYPE_NUM_LARGE,
  ERR_TYPE_NUM_SMALL,
  ERR_TYPE_REQUIRED,
  ERR_TYPE_STR_LONG,
  ERR_TYPE_STR_SHORT,
  FIELD_TYPE_NUMBER,
  FIELD_TYPE_TXTAREA,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useFireFightingExercisesSchema() {
  const { t } = useTranslation();

  const quantity = useMemo(() => {
    return {
      element: 'quantity',
      propName: 'quantity',
      type: FIELD_TYPE_NUMBER,
      placeholderI18nKey: 'business:QuestionPage.forms.fireFighting.quantityPlaceholder',
      styleInputParentWidth: '20rem',
      dropdown: {
        values: [
          {
            name: 'kg',
            displayNameKey: 'business:emissionFactors.volumes.kg',
          },
        ],
        element: 'firefighting-dropdown',
        // ifSingleNoBorder: true,
      },
      label: 'Quantity:',
      validation: [
        {
          rule: ERR_TYPE_REQUIRED,
          errCode: 'ERRNOQUANTITY',
          errStr: t('business:Errors.fuelType.fuelQuantity'),
        },
        {
          rule: ERR_TYPE_NUM_SMALL,
          errCode: 'ERRQUANTITYTOOLOW',
          errStr: t('business:Errors.fuelType.fuelQuantity'),
          value: 0,
        },
        {
          rule: ERR_TYPE_NUM_LARGE,
          errCode: 'ERRQUANTITYTOOHIGH',
          errStr: t('business:Errors.fuelType.fuelQuantity'),
          value: 999999,
        },
      ],
    };
  }, [t]);

  const dataSource = useMemo(() => {
    return {
      type: FIELD_TYPE_TXTAREA,
      propName: 'dataSource',
      element: 'data_source',
      labelI18nKey: 'business:QuestionPage.forms.fireFighting.howCollected',
      descriptionI18nKey: 'business:QuestionPage.forms.fireFighting.explanation',
      placeholderI18nKey: 'business:QuestionPage.forms.fireFighting.dataPlaceholder',
      validation: [
        {
          rule: ERR_TYPE_REQUIRED,
          errCode: 'ERRDATASOURCE',
          errStr: t('business:Errors.dataSource.provide'),
        },
        {
          rule: ERR_TYPE_STR_SHORT,
          errCode: 'ERRDATASOURCETOOSHORT',
          errStr: t('business:Errors.dataSource.tooShort'),
          value: 5,
        },
        {
          rule: ERR_TYPE_STR_LONG,
          errCode: 'ERRDATASOURCETOOLONG',
          errStr: t('business:Errors.dataSource.tooLong'),
          value: 3000,
        },
      ],
    };
  }, [t]);

  const pageSchema = useMemo(() => [quantity, dataSource], [quantity, dataSource]);

  return {
    pageSchema,
    isSingularQuestion: true,
  };
}
